import * as React from 'react';

import { CustomizeColumnsModalProvider } from '../../../context/customizeColumnsModalContext';
import { DashboardModal } from './DashboardModal';
import { IntentsModal } from './intents/IntentsModal';

export const ModalsProvider = ({ children }: { children: React.ReactNode }) => (
    <CustomizeColumnsModalProvider>
        <DashboardModal>
            <IntentsModal>{children}</IntentsModal>
        </DashboardModal>
    </CustomizeColumnsModalProvider>
);
